export default "__VITE_ASSET__CJA7XEmP__"